/* Millimili 3.0 — header davranışı. Sahibi: header ajanı. İşaretleme: snippets/mm3-nav*.liquid.
   - Büyük menü (≥1200): fareyle üzerine gelince açılır, odak içeri girince açılır (klavye), Escape kapatır ve
     odağı üst öğeye döndürür, ↓ ilk linke götürür; dokunmatikte ilk dokunuş açar, ikinci dokunuş linke gider.
   - Mobil çekmecedeki akordeonun aria-expanded durumu (Wonder yalnız sınıf değiştiriyor).
   - Mobil arama düğmesinden açılan arama kapanınca odak o düğmeye döner.
   - Sepet linkinin erişilebilir adı ("Bag, N items") sepet yenilenince güncellenir. */
(() => {
  const header = document.querySelector('page-header.mm3-hdr');
  if (!header) return;

  const desk = window.matchMedia('(min-width: 1200px)');
  const items = Array.from(header.querySelectorAll('.mm3-nav__item--mega'));
  const OPEN_DELAY = 70;
  const CLOSE_DELAY = 160;
  let openItem = null;

  const linkOf = (item) => item.querySelector(':scope > .mm3-nav__link');

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    linkOf(item)?.setAttribute('aria-expanded', String(open));
    if (open) openItem = item;
    else if (openItem === item) openItem = null;
    header.classList.toggle('mm3-hdr--open', Boolean(openItem));
    document.body.classList.toggle('mm3-mega-open', Boolean(openItem));
  }

  function closeAll(except) {
    items.forEach((i) => {
      if (i !== except && i.classList.contains('is-open')) setOpen(i, false);
    });
  }

  items.forEach((item) => {
    const link = linkOf(item);
    let timer = null;
    let lastPointer = 'mouse';

    item.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType; });

    item.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { closeAll(item); setOpen(item, true); }, openItem ? 0 : OPEN_DELAY);
    });

    item.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(item, false), CLOSE_DELAY);
    });

    item.addEventListener('focusin', () => {
      if (!desk.matches || item.dataset.escaped) return;
      clearTimeout(timer);
      closeAll(item);
      if (!item.classList.contains('is-open')) setOpen(item, true);
    });

    item.addEventListener('focusout', (e) => {
      if (item.contains(e.relatedTarget)) return;
      delete item.dataset.escaped;
      if (e.relatedTarget) setOpen(item, false);
    });

    // dokunmatik (≥1200 tablet): ilk dokunuş paneli açar
    link?.addEventListener('click', (e) => {
      if (!desk.matches || lastPointer === 'mouse') return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        closeAll(item);
        setOpen(item, true);
      }
    });

    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        e.preventDefault();
        item.dataset.escaped = '1';
        setOpen(item, false);
        link?.focus();
      } else if (e.key === 'ArrowDown' && e.target === link) {
        e.preventDefault();
        delete item.dataset.escaped;
        closeAll(item);
        setOpen(item, true);
        item.querySelector('.mm3-mega a')?.focus();
      }
    });
  });

  document.addEventListener('pointerdown', (e) => {
    if (openItem && !openItem.contains(e.target)) closeAll();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openItem) {
      const link = linkOf(openItem);
      openItem.dataset.escaped = '1';
      closeAll();
      link?.focus();
    }
  });
  desk.addEventListener?.('change', (e) => { if (!e.matches) closeAll(); });

  // çekmece akordeonu: aria-expanded eşlemesi
  document.querySelectorAll('.mm3-drawer .wt-page-nav-mega__link--parent').forEach((a) => {
    const sync = () => a.setAttribute('aria-expanded', String(a.classList.contains('submenu-opened')));
    new MutationObserver(sync).observe(a, { attributes: true, attributeFilter: ['class'] });
    sync();
  });

  // sepet linkinin erişilebilir adı "Bag, N items": Wonder sepet güncellenince #cart-icon-bubble içini yeniden basıyor
  // (sections/cart-icon-bubble.liquid, etiketi "Cart") → sayı sayaçtan okunur, ad yeniden yazılır
  const bag = document.getElementById('cart-icon-bubble');
  if (bag) {
    const syncBag = () => {
      const n = parseInt(bag.querySelector('.wt-header__panel__counter')?.textContent, 10) || 0;
      const label = `Bag, ${n} ${n === 1 ? 'item' : 'items'}`;
      if (bag.getAttribute('aria-label') !== label) bag.setAttribute('aria-label', label);
    };
    new MutationObserver(syncBag).observe(bag, { childList: true, subtree: true, characterData: true });
    syncBag();
  }

  // mobil arama düğmesi: arama kapanınca odak geri
  let lastSearchTrigger = null;
  header.querySelectorAll('[data-mm3-search-trigger]').forEach((btn) => {
    btn.addEventListener('click', () => { lastSearchTrigger = btn; });
  });
  new MutationObserver(() => {
    if (lastSearchTrigger && !document.body.classList.contains('search-overlay-on')) {
      const btn = lastSearchTrigger;
      lastSearchTrigger = null;
      setTimeout(() => { if (btn.offsetParent) btn.focus(); }, 30);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
